import {
  Component,
  OnChanges,
  ElementRef,
  ViewChild,
  SimpleChanges,
  HostListener,
  Output,
  EventEmitter,
} from '@angular/core';
import { AgentService } from 'src/app/agent/services/agent.service';
import { BaseComponent } from 'src/app/system-common/base/base.component';
import { SettingService } from 'src/app/system-common/services/setting.service';
import * as moment from 'moment';
import * as Chart from 'chart.js';
import { Router } from '@angular/router';

@Component({
  selector: '',
  template: '',
})
export class AgentPerformanceStatusHandlerComponent extends BaseComponent<AgentService> implements OnChanges {
  @ViewChild('dateTimeRange') dateTimeRange: any;
  @ViewChild('frequncy') frequncy: ElementRef;
  @Output() closeChart = new EventEmitter<string>();
  public dateTimeRange1: Date[];
  public agentPerformanceStatusData;
  public widthInPX;
  minDate: Date;
  maxDate: Date;
  frequency: string;
  data: Date;
  currFreqModel: any;
  modelSave: boolean;
  modalSaveCheck: boolean;
  model1: boolean;
  model2: boolean;
  model3: boolean;
  FromDate;
  ToDate;

  agentPerformance;
  chart: Chart;
  chartView;
  series = [];
  calculatedPerformance = [];
  performanceMonth = [];
  inlineChartEvent: string;
  date1 = new Date();
  date = new Date();
  startDate;
  endDate;
  selectedGraphPer;
  isCustom: boolean;
  isBtnCustomClicked: boolean;
  lineChartData: any;
  lineChartOptions: any;
  public currentSelectedTheme;

  constructor(agentService: AgentService, public settingService: SettingService, public router: Router) {
    super(agentService);
    this.modelSave = false;
    this.modalSaveCheck = false;
    this.model1 = false;
    this.model2 = false;
    this.model3 = false;
    this.inlineChartEvent = 'M';
    this.isCustom = false;
    this.isBtnCustomClicked = false;
    console.log('date', this.date);
  }

  /**
   * HostListener Decorator that declares a DOM event to listen for,
   * and provides a handler method to run when that event occurs.
   * The onresize event occurs when the browser window has been resized
   * @returns numeric value.
   */
  @HostListener('window:resize', ['$event'])
  onWindowResize(event) {
    if (event.target != undefined) {
      this.settingService.setWindowWidth(window);
      this.widthInPX = this.settingService.getWindowWidth();
    }
  }

  ngOnInit() {
    this.currentSelectedTheme = this.settingService.getSessionStorageValue('currentSelectedTheme');
    if (
      (this.currentSelectedTheme != undefined || this.currentSelectedTheme != null) &&
      this.currentSelectedTheme.endsWith('.css')
    ) {
      this.currentSelectedTheme = this.currentSelectedTheme.replace('.css', '');
    }
    setTimeout(() => {
      this.initLineGraph(this.inlineChartEvent);
    }, 10);
    this.settingService.setWindowWidth(window);
    this.widthInPX = this.settingService.getWindowWidth();
  }

  ngOnChanges(changes: SimpleChanges): void {}

  onSelectDateRange() {
    $('#myForm').toggle();
    this.isBtnCustomClicked = true;
    this.isCustom = true;
  }

  initLineGraph(event) {
    if (this.isBtnCustomClicked) {
      $('#myForm').toggle();
      this.isBtnCustomClicked = false;
    }

    this.inlineChartEvent = event;
    this.FromDate = this.startDateData(this.dateTimeRange.nativeElement.value);
    this.ToDate = this.endDateData(this.dateTimeRange.nativeElement.value);

    if (this.inlineChartEvent === 'W') {
      this.date1.setMonth(this.date.getMonth() - 3);
    } else if (this.inlineChartEvent === 'M') {
      // this.date = new Date();
      this.date1.setFullYear(this.date.getFullYear(), this.date.getMonth() - 6, this.date.getDate());
    } else if (['D', 'Q', 'Weekly', 'Monthly'].includes(this.inlineChartEvent)) {
      this.date1 = this.FromDate;
      this.date = this.ToDate;
    }

    this.startDate = moment(this.date1).format('DD-MMM-YYYY').toString();
    this.endDate = moment(this.date).format('DD-MMM-YYYY').toString();

    this.service.getAgentPerformanceStatus(event, this.startDate, this.endDate).subscribe(
      (agentPerformanceStatus) => {
        const labels: string[] = [];
        const values: number[] = [];

        for (let [key, value] of Object.entries(agentPerformanceStatus['data']['result'])) {
          labels.push(key);
          values.push(value as number);
        }

        this.lineChartData = {
          labels: labels,
          datasets: [
            {
              data: values,
              label: 'Performance',
              borderColor: 'hsl(206,85%,57.5%)',
              fill: false,
              tension: 0.3,
            },
          ],
        };

        this.lineChartOptions = {
          responsive: true,
          maintainAspectRatio: false,
          layout: {
            padding: { left: 30, right: 30, top: 20, bottom: 20 },
          },
          legend: {
            align: 'center',
            position: 'bottom',
            labels: {
              fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
              fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
              fontSize: 12,
            },
          },
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                const label = data.datasets[tooltipItem.datasetIndex].label;
                const value = tooltipItem.yLabel;
                return ` ${label} : ${value.toLocaleString()}`;
              },
            },
            bodyFontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
          },
          scales: {
            xAxes: [
              {
                scaleLabel: {
                  display: true,
                  labelString: 'Period',
                  fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                  fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
                },
                gridLines: {
                  color: this.currentSelectedTheme === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)',
                  zeroLineColor: this.currentSelectedTheme === 'dark' ? '#fff' : 'rgba(10, 10, 10, 0.2)',
                  drawBorder: true,
                  lineWidth: 1,
                },
                ticks: {
                  fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
                  fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                  fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
                },
              },
            ],
            yAxes: [
              {
                display: true,
                ticks: {
                  beginAtZero: true,
                  min: 0,
                  fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
                  fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                  fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
                  callback: function (value) {
                    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                  },
                },
                gridLines: {
                  color: this.currentSelectedTheme === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.1)',
                  zeroLineColor: this.currentSelectedTheme === 'dark' ? '#fff' : 'rgba(10, 10, 10, 0.2)',
                  drawBorder: true,
                  lineWidth: 1,
                },
                scaleLabel: {
                  display: true,
                  labelString: 'Performance Count',
                  fontSize: this.settingService.isMobileViewRendered() ? 8 : 12,
                  fontColor: this.currentSelectedTheme == 'dark' ? '#fff' : '#000',
                  fontFamily: 'montserratregular, Arial, Helvetica, sans-serif',
                },
              },
            ],
          },
          plugins: {
            datalabels: false,
          },
        };
      },
      (error) => {
        console.error('Error:', error);
      }
    );
  }

  startDateData(data) {
    data = data.split(' ', 3);
    if (this.frequency != null || this.frequency != undefined) {
      let sdate = new Date(data[0]);
      return sdate;
    }
  }

  endDateData(data) {
    data = data.split(' ', 3);
    if (this.frequency != null || this.frequency != undefined) {
      let edate = new Date(data[2]);
      return edate;
    }
  }

  onSaveDate() {
    setTimeout(() => {
      this.openModal('agentPerformanceStatusModal');
    }, 10);
  }

  save(data, frequency) {
    if ((this.frequency == null && this.frequency == undefined) || this.frequency == 'Select') {
      this.modelSave = true;
      this.onSaveDate();
    } else if (
      this.dateTimeRange.nativeElement.liveValue == '' ||
      this.dateTimeRange.nativeElement.liveValue == undefined
    ) {
      this.modelSave = true;
      this.onSaveDate();
    } else {
      const diffDays = this.calculateDiff(this.dateTimeRange.nativeElement.value);
      if (diffDays >= 30 && diffDays <= 90 && frequency === 'D') {
        this.model1 = true;
        this.model2 = false;
        this.model3 = false;
        this.onSaveDate();
      } else if (diffDays > 90 && diffDays <= 365 && (frequency === 'D' || frequency === 'Weekly')) {
        this.model1 = false;
        this.model2 = true;
        this.model3 = false;
        this.onSaveDate();
      } else if (diffDays > 365 && frequency != 'Q') {
        this.model1 = false;
        this.model2 = false;
        this.model3 = true;
        this.onSaveDate();
      } else {
        setTimeout(() => {
          $('#myForm').hide();
          this.closeMyModal();
          this.initLineGraph(this.frequency);
        }, 10);
      }
    }
  }

  clearData() {
    if (this.dateTimeRange && this.dateTimeRange.nativeElement) {
      this.dateTimeRange.nativeElement.value = '';
      this.dateTimeRange.nativeElement.liveValue = '';
    }
    this.frequency = null;
    const frequencySelect = document.getElementById('inputGroupSelect01') as HTMLSelectElement;
    if (frequencySelect) {
      frequencySelect.selectedIndex = 0;
    }

    this.isCustom = false;
    this.isBtnCustomClicked = false;
    console.log('this.dateTimeRange', this.dateTimeRange);

    $('#myForm').hide();
    this.initLineGraph('M');
  }

  clear() {
    $('#agentPerformanceStatusModal').hide();
  }

  closeMyModal() {
    $('#myForm').hide();
    this.isBtnCustomClicked = !this.isBtnCustomClicked;
  }

  closePopUpModal() {
    setTimeout(() => {
      this.closeModal('agentPerformanceStatusModal');
    }, 10);
  }

  selectedRange(value) {
    if (this.dateTimeRange != null && this.dateTimeRange != undefined) {
      this.frequency = value.target.value;
      this.modelSave = false;
      const diffDays = this.dateTimeRange;
      if (diffDays >= 30 && diffDays <= 90 && value.target.value === 'D') {
        this.model1 = true;
        this.model2 = false;
        this.model3 = false;
        this.onSaveDate();
      } else if (
        diffDays > 90 &&
        diffDays <= 365 &&
        (value.target.value === 'D' || value.target.value === 'Weekly')
      ) {
        this.model1 = false;
        this.model2 = true;
        this.model3 = false;
        this.onSaveDate();
      } else if (diffDays > 365 && value.target.value != 'Q') {
        this.model1 = false;
        this.model2 = false;
        this.model3 = true;
        this.onSaveDate();
      }
    }
  }

  calculateDiff(data) {
    data = data.split(' ', 3);
    let firstDate = data[0];
    let secondDate = data[2];

    var date1 = new Date(firstDate);
    var date2 = new Date(secondDate);
    let date = date1;
    let currentDate = date2;
    let days = Math.floor((currentDate.getTime() - date.getTime()) / 1000 / 60 / 60 / 24);
    return days;
  }

  // Close the Chart on click of the close button
  onCloseClick() {
    this.closeChart.emit(Chart);
  }
}
